<template>
	<div class="main">
		<popupLayout>
			<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
			<div class="bootbox-body">
				<header class="form-group mb-lg">
					<label class="col-md-12" style="font-size: 2em;">獎勵及違規輔導記錄</label>
				</header>
				<div class="row form-group mb-lg">
					<label class="col-md-12">輔導記錄</label>
					<div class="col-md-12">
						<textarea class="form-control" name="tutorRecord" v-model="violateRecord.tutorRecord" rows="5" maxlength="400" v-validate="'required|max:400'"></textarea>
						<span class="text-danger" v-show="errors.has('tutorRecord')">{{ errors.first('tutorRecord') }}</span>
					</div>
				</div>
				<div class="row form-group mb-lg">
					<label class="col-md-12">輔導時間</label>
					<div class="col-md-12">
						{{violateRecord.tutorRecord ? customFormatter(violateRecord.upDate, "YYYY/MM/DD HH:mm:ss") : ""}}
					</div>
				</div>
				<div class="row form-group mb-lg">
					<label class="col-md-12">銷點類型</label>
					<div class="col-md-12" v-if="isShow">
						<select class="form-control" v-model="violateRecord.revokeName" name="revokeName" v-validate="'required'">
							<option :value="null">--請選擇--</option>
							<option v-for="(award, index) in awardTypeList" :key="index" :value="award.commValue">{{award.commValue}}</option>
						</select>
						<span class="text-danger" v-show="errors.has('revokeName')">{{ errors.first('revokeName') }}</span>
						
					</div>
					<div class="col-md-12" v-else>
						<span>{{violateRecord.revokeName}}</span>
					</div>
				</div>
				<div class="row form-group mb-lg">
					<label class="col-md-12">點數：</label>
					<div class="col-md-12" v-if="isShow">
						<input type="number" v-model.number="violateRecord.revokePoint" name="revokePoint" class="form-control" v-validate="'required'"/>
						<span class="text-danger" v-show="errors.has('revokePoint')">必填欄位</span>
					</div>
					<div class="col-md-12" v-else>
						<span>{{violateRecord.revokePoint ? violateRecord.revokePoint : '--'}}</span>
					</div>
				</div>
				<div class="row form-group mb-lg">
					<label class="col-md-12">銷點原因說明：</label>
					<div class="col-md-12">
						{{violateRecord.revokeRecordRemark}}
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-offset-4 col-md-4">
						<div class=" col-md-offset-3 col-md-6">
							<a class="btn btn-danger btn-block" @click="saveTotur">送出</a>
						</div>
					</div>
				</div>
			</div>
		</popupLayout>
	</div>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:{
		violateRecord:{
			type:Object,
			default:{}
		}
	},
	data(){
		return {
			awardTypeList:[],
			isShow:false
		}
	},
	mounted(){
		this.isShow = this.violateRecord.revokeApply == `Y` && !this.violateRecord.revokePoint;
		this.init();
	},
	methods:{
		init(){
			const api = "/api/Common/commCodeList/AWARD";
			this.$axios.post(api, JSON.stringify({})).then(resp => {
				this.awardTypeList = resp.data.data;
			});
		},
		closePopup() {
			this.$parent.showTutorPopupControl(false);
		},
		saveTotur(){
			let _this = this;
			this.$validator.validateAll().then(result =>{
				if(result){
					const api = "/api/Violate/saveViolateRecord/";
					this.$axios.post(api, JSON.stringify(this.violateRecord)).then(resp => {
						bootbox.alert(resp.data.msg, function(){
							if(resp.data.status == "success"){
								_this.$router.go(-1);
							}
						});
					});
				}else{
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		}
	}
}
</script>